import { withLoyaltyStore } from "../../utils/withLoyaltyStore";

import { LoyaltyPushBlock as LoyaltyPushBlockBase } from "./LoyaltyPushBlock";

export type * from "./LoyaltyPushBlock";
export const LoyaltyPushBlock = withLoyaltyStore(LoyaltyPushBlockBase, "LoyaltyPushBlock");
